import { FC } from 'react';
import useResponsiveRedux from '../Hooks/useResponsiveRedux';
import Messaggi from '../../pages/Messaggi';
import MessaggiMobile from '../../pages/Mobile/MessaggiMobile';

const MessaggiResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <MessaggiMobile /> : <Messaggi />;
};

export default MessaggiResponsive;
